<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.BillCode }}</td>
                <td>{{ item.CustomerUserName }}</td>
                <td>{{ item.CustomerFullName }}</td>
                <td class="text-right">{{ item.ProductCount | currency }}</td>
                <td class="text-right">{{ item.TotalPackageCount | currency }}</td>
                <td class="text-right">{{ item.AmountVND | currency }}</td>
                <td class="text-right">{{ item.DomesticTransportFee | currency }}</td>
                <td class="text-right">{{ item.DoorDeliveryFee | currency }}</td>
                <td class="text-right">{{ item.OtherDeliveryFee | currency }}</td>
                <td class="text-right">{{ item.FinalAmount | currency }}</td>
                <td>
                  <v-chip small :color="getStatusColor(item.Status, bill_status_list)">
                    {{ item.Status | display_value(bill_status_list) }}
                  </v-chip>
                </td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td>{{ item.ExportDate | display_date }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">visibility</v-icon>
                  <v-icon medium class="mr-2" color="green darken-2" @click="printBill(item)">print</v-icon>
                  <v-icon medium class="mr-2" color="blue darken-2" @click="exportExcel(item.ID)">file_download</v-icon>
                  <v-icon v-if="hasEditPermission" medium @click="deleteItem(item.ID)">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import createPermissionMixin from "@/mixins/permissionMixin";
import { print_bill } from "@/commons/hpod";
import _ from "lodash";

export default {
  mixins: [createPermissionMixin('bill_list')],
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    return {
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "bill_list",
      filterConditions: [],
      quickFilterConditions: [],
      bill_status_list: configs.BILL_STATUS_LIST,
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.bill.all.data,
      total_rows: state => state.bill.all.total,
      loading: state => state.bill.loading
    }),
    accountantRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
    },
    storeRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.StoreBatch || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.StoreEcomerce;
    },
    headers() {
      return [
        {
          text: "Mã bill",
          value: "BillCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã KH",
          value: "CustomerUserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Tên KH",
          value: "CustomerFullName",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Số mã hàng",
          value: "ProductCount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tổng kiện",
          value: "TotalPackageCount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Cước vận chuyển",
          value: "AmountVND",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Cước nội địa",
          value: "DomesticTransportFee",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí giao hàng",
          value: "DoorDeliveryFee",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí khác",
          value: "OtherDeliveryFee",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tổng tiền",
          value: "FinalAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.BILL_STATUS_LIST,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Ngày xuất",
          value: "ExportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
          width: "160px"
        }
      ];
    }
  },
  methods: {
    getStatusColor(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bill/getList", param);
    },
    gotoDetail: function(id) {
      this.$router.push({
        name: "BillDetail",
        params: {
          Pid: id,
          title: `Chi tiết xuất hàng (#${id})`
        }
      });
    },
    createData() {
      if (this.storeRole || this.accountantRole) {
        sendErrorNotice('Bạn không có quyền thực hiện hành động này');
        return;
      }
      this.$router.push({
        name: "BillDetail",
        params: {
          Pid: 'new',
          title: 'Tạo phiếu xuất hàng'
        }
      });
    },
    deleteItem: function(id) {
      if (!this.hasEditPermission) {
        return;
      }
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    exportExcel: function(id) {
      this.$store.dispatch("bill/exportDetail", id);
    },
    printBill: function(item) {
      // Lấy thông tin bill và danh sách sản phẩm để in
      this.$store.dispatch("bill/getDetail", item.ID).then(() => {
        const bill = this.$store.state.bill.selected;
        const products = bill.Products || [];
        if (products.length > 0) {
          bill.CustomerFullName = item.CustomerFullName;
          bill.CustomerUserName = item.CustomerUserName;
          print_bill(bill, products);
        } else {
          this.$root.$emit('SHOW_ERROR_MESSAGE', 'Không có hàng hóa để in');
        }
      });
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
  },
  mounted() {
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bill/removeDetail", id);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
